import { useNavigate } from 'react-router-dom';
import './StartPage.css';
import LaunchBay from './img/launch-bay.png';

const StartPage = () => {
  const navigate = useNavigate();
  return (
    <div className="start-bg">
      <p className="start-title">Welcome to Martian Chronicles!</p>
      <button className="start-btn" onClick={() => navigate('/fork')}>Start</button>
      <img src={LaunchBay} alt="Launch bay" className="start-image"/>
    </div>
  );
};

export default StartPage;